/**
 * OW-513 — sanitize referral attribution before first write.
 * Empty / self-referral → no attribution (signup still succeeds).
 */
export function sanitizeReferralCode(
  raw: string | null | undefined,
  newUserId?: string | null,
): string {
  const code = (raw ?? '').trim();
  if (!code) return '';
  if (newUserId && code === newUserId.trim()) return '';
  return code;
}

/**
 * Once set, existing wins — clients must not overwrite attribution.
 */
export function preserveImmutableReferenceCode(
  existing: string | null | undefined,
  incoming: string | null | undefined,
): string {
  const current = (existing ?? '').trim();
  if (current) return current;
  return sanitizeReferralCode(incoming);
}
